/**
 * StagingBadge — small amber ribbon shown only on the staging environment.
 *
 * Visibility rules (any of the following → show):
 *   1. REACT_APP_ENV is the string "staging" at build time, OR
 *   2. the hostname contains "staging" (e.g. staging.smartly.cooking, smartly-staging.emergent.host).
 *
 * Never shown on:
 *   - smartly.cooking
 *   - www.smartly.cooking
 *   - any host where the two rules above are false (incl. localhost during dev unless REACT_APP_ENV=staging).
 *
 * The badge is fixed at the very top centre, behind the page header z-index,
 * does not block taps, and does not touch the bottom-navigation area or
 * safe-area-inset-bottom. It is purely a visual marker for QA.
 */

const PRODUCTION_HOSTS = new Set(["smartly.cooking", "www.smartly.cooking"]);


const shouldShowStagingBadge = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const host = (window.location && window.location.hostname) || "";
  if (PRODUCTION_HOSTS.has(host)) {
    return false;
  }

  const envFlag = (process.env.REACT_APP_ENV || "").toLowerCase();
  if (envFlag === "staging") {
    return true;
  }

  return host.toLowerCase().includes("staging");
};


export const StagingBadge = () => {
  if (!shouldShowStagingBadge()) {
    return null;
  }

  return (
    <div
      role="status"
      aria-label="Staging environment"
      className="pointer-events-none fixed left-1/2 z-[140] -translate-x-1/2 rounded-full border border-amber-400/70 bg-amber-100/95 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.28em] text-amber-900 shadow-[0_8px_22px_rgba(180,120,0,0.18)]"
      style={{ top: "max(0.5rem, env(safe-area-inset-top))" }}
      data-testid="staging-badge"
    >
      Staging
    </div>
  );
};
